import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac89a526"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "single-wrapper" }
const _hoisted_2 = ["id"]

import { ref, onMounted, nextTick } from 'vue'
import Text from '@/components/text'
import EZUIKit from 'ezuikit-js'


export default /*#__PURE__*/_defineComponent({
  __name: 'single-video',
  props: ['id', 'name', 'accessToken', 'address'],
  setup(__props) {

const props = __props

const themeData = {
  header: {
    color: '#1890ff',
    activeColor: '#FFFFFF',
    backgroundColor: '#000000',
    btnList: [],
  },
  footer: {
    color: '#FFFFFF',
    activeColor: '#1890FF',
    backgroundColor: '#00000021',
    btnList: [
      {
        iconId: 'play',
        part: 'left',
        defaultActive: 1,
        memo: '播放',
        isrender: 1,
      },
      {
        iconId: 'capturePicture',
        part: 'left',
        defaultActive: 0,
        memo: '截屏按钮',
        isrender: 1,
      },
      {
        iconId: 'sound',
        part: 'left',
        defaultActive: 0,
        memo: '声音按钮',
        isrender: 1,
      },
      {
        iconId: 'recordvideo',
        part: 'left',
        defaultActive: 0,
        memo: '录制按钮',
        isrender: 1,
      },
      {
        iconId: 'hd',
        part: 'right',
        defaultActive: 0,
        memo: '清晰度切换按钮',
        isrender: 1,
      },
      {
        iconId: 'webExpend',
        part: 'right',
        defaultActive: 0,
        memo: '网页全屏按钮',
        isrender: 1,
      },
      {
        iconId: 'expend',
        part: 'right',
        defaultActive: 0,
        memo: '全局全屏按钮',
        isrender: 1,
      },
    ],
  },
}

const videoId = ref('single-video-')
onMounted(async () => {
  nextTick(() => {
    init()
  })
})

const init = async () => {
  const { accessToken, address } = props
  const player = new EZUIKit.EZUIKitPlayer({
    id: videoId.value + props.id, // 视频容器ID
    accessToken,
    url: address,
    width: 788,
    height: 443,
    // template: 'pcLive',
    themeData,
    handleError: (err: any) => {
      console.log(err)
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "video",
      id: videoId.value + props.id
    }, null, 8, _hoisted_2),
    _createVNode(_unref(Text), {
      content: props.name
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.name), 1)
      ]),
      _: 1
    }, 8, ["content"])
  ]))
}
}

})